import { CardSection, CardSubSection } from '@side/pantry';
import { BuyerAgreementSection } from './BuyerAgreementSection';
import { BuyerAgentsAutocomplete } from './BuyerDetailsSection/BuyerAgentsAutocomplete';
import { BuyerFormsGroup } from './BuyerDetailsSection/BuyerFormsGroup';

export const NewBuyerCardSections = () => (
  <>
    <CardSection cardTitle="Buyer's Agent">
      <CardSubSection>
        <BuyerAgentsAutocomplete />
      </CardSubSection>
    </CardSection>
    <CardSection cardTitle="New Buyer">
      <CardSubSection>
        <BuyerFormsGroup />
      </CardSubSection>
    </CardSection>
    <CardSection cardTitle="Buyer Agreement">
      <CardSubSection>
        <BuyerAgreementSection />
      </CardSubSection>
    </CardSection>
  </>
);
